import Vue from "vue";
import App from "./App.vue";
import router from "./router/";
import store from "./store";
import "vuetify/dist/vuetify.min.css";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "font-awesome/css/font-awesome.css";
import VueRouter from "vue-router";
import Socket from "./mixins/socket";
import axios from "axios";
import VueAxios from "vue-axios";
import VueIziToast from "vue-izitoast"; // notification messages
import "izitoast/dist/css/iziToast.css";
import VueSweetalert2 from "vue-sweetalert2";
import Helpers from "./mixins/helpers";
import VueQRCodeComponent from "vue-qrcode-component";
import VueSignature from "vue-signature-pad";

import VueSession from "vue-session";
import IdleVue from "idle-vue";
import vuetify from "./plugins/vuetify";
import JsonCSV from "vue-json-csv";

Vue.config.productionTip = false;
VueRouter.mode = "history";

// plugin setup
Vue.use(VueRouter);
Vue.use(VueAxios, axios);
Vue.use(VueIziToast);
Vue.use(VueSession);
Vue.use(Socket);
Vue.mixin(Helpers);
Vue.use(VueSweetalert2);
Vue.use(VueSignature);
Vue.component("downloadCsv", JsonCSV);
Vue.use(require("vue-moment"));
Vue.use(require("vue-cookies"));

Vue.$cookies.config("7d");

// session time out
const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 100
});

Vue.component("qr-code", VueQRCodeComponent);

new Vue({
  router,
  store: store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
// https://github.com/gerardreches/vue-qrcode-component#installation
